var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCooling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3076 0V9.98429L49.1499 3.54883L53.8045 8.38989L42.3076 19.2035V33.6689L55.0769 26.3655L58.7512 11.2187L65.3144 12.7874L63.1397 21.7559L71.7932 16.8055L75.1754 22.6109L66.4505 27.6063L75.5 30.255L73.5914 36.6712L58.3877 32.2159L45.7742 39.4229L58.511 46.707L73.5914 42.2902L75.5 48.7L66.5738 51.3166L75.2273 56.2669L71.8451 62.0724L63.1137 57.0834L65.3144 66.1741L58.7512 67.7428L55.0444 52.4738L42.3076 45.1897V59.7193L53.8045 70.533L49.1499 75.374L42.3076 68.9386V79H35.5366V69.0286L28.7852 75.3805L24.1306 70.533L35.5366 59.8093V45.2797L22.9556 52.4738L19.2488 67.7428L12.6856 66.1741L14.8863 57.0834L6.09644 62.1109L2.70774 56.3055L11.4262 51.323L2.5 48.7064L4.40858 42.2902L19.489 46.7134L32.2258 39.4293L19.6123 32.2159L4.40858 36.6712L2.5 30.255L11.5495 27.6063L2.75318 22.5723L6.14189 16.7669L14.8603 21.7559L12.6856 12.7874L19.2488 11.2187L22.9231 26.3655L35.5366 33.5724V19.1135L24.1306 8.38989L28.7852 3.54883L35.5366 9.89429V0H42.3076Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooling);
export default __webpack_public_path__ + "static/media/cooling.6842b1b5af38c19b3d1e0368e6ff8ae1.svg";
export { ForwardRef as ReactComponent };